import templateUrl from './pending-employee-modal.component.html';
import { SiteModuleEnum } from '../../../core/enum/site-module';
import { sortIcdOfficeByOwner } from '../../../core/services/data-services/icd-office.service';
import { MinimumWageReviewModal } from '../../wage-policy/minimum-wage-review-modal.component';
import moment from 'moment';
import angular from 'angular';
import { IMPLEMENTED_PROVINCE_STATE_IDS } from '../../onboarding-document/implemented-states';

export const PendingEmployeeModalComponent = {
    templateUrl,
    controller: PendingEmployeeController,
    controllerAs: "vm",
    bindings: {
        resolve: '<',
        close: "&",
        dismiss: "&"
    }
}

function PendingEmployeeController($q, $uibModal, $state, $scope, utilityService, employeeService, permissionGrantService, localeService, onboardingDocumentService, employmentRecordEditContextFactory,
    icdOfficeService, payrollService, wagePolicyService, stateProvinceService, icdCorporationService) {
    'ngInject'
    const vm = this;
    vm.form = {};
    vm.onbPhone = false;
    vm.onbEmail = false;
    vm.resolve;
    vm.onClose = onClose;
    vm.onSubmit = onSubmit;
    vm.onRehire = onRehire;
    vm.matchStates = matchStates;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.showMinimumWageRequirements = showMinimumWageRequirements;
    vm.diffTaxState;
    vm.serverValidationMessages;
    vm.stateValidationMessage;
    vm.validateMinimumWage = validateMinimumWage;
    vm.onChangeCompensationProfile = onChangeCompensationProfile;
    vm.onChangePhoneNumber = onChangePhoneNumber;
    vm.onChangeEmailAddress = onChangeEmailAddress;
    vm.emailAddressPending = false;
    /* vm.$onInit = onInit;*/
    vm.fullName;
    vm.formMapping = { '5': 'Federal W4', '-2': 'W9', '2': 'State W4', '3': 'I9' };
    vm.testMsg = 'min wage error';
    vm.user;
    vm.hasApprovedOnboardingProfile = false;
    vm.hasOnboardingProfile = true;
    vm.hireDate;
    vm.selectedOffice;
    vm.wagePolicies;
    vm.employee;
    vm.onChangeUserName = onChangeUserName;
    vm.setContractor = setContractor;
    vm.userNamePending = false;
    vm.wagePolicy;
    vm.addlInputs;
    vm.originalUserName;
    vm.hasTaxInfo = false;
    vm.empContractor = 0;
    const ROSTER_MODULE = 3;
    vm.usernameValid = false;
    vm.telemapperLinked = false;
    vm.isIndividualOrCompany = 'i'
    vm.isMeridianDuplicate = false;
    vm.triggerDuplCheck = false;
    vm.oneYearAgo = moment().add(-1, "year").toDate();;
    vm.hireDateOptions = {
        //min: new Date(),
        change: function () {
            vm.editForm.HireDate.$setTouched();
            console.log(this.value());
        }
    };
    vm.application;
    vm.initData = [];
    vm.editData = [];
    vm.duplicates = [];
    vm.minWageOptions = {
        change: function (e) {
            $scope.$evalAsync(function () {
                vm.validateMinimumWage();
            });
        }
    }

    //vm.triggerOnboardingEmail;

    vm.$onInit = function () {
        utilityService.showLoading();
        console.log(vm.resolve);
        //vm.oneYearAgo = new Date();
        //oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

        //vm.hireDateOptions = {
        //    min: vm.resolve.isNew ? oneYearAgo : null,
        //    change: function () {
        //        vm.editForm.HireDate.$setTouched();
        //        console.log(this.value());
        //    }
        //};

        vm.hasOnboardingProfile = vm.resolve.onboardingApplication != null && vm.resolve.onboardingApplication.length > 0 && vm.resolve.onboardingApplication.find(x => x.EmployeeId === Number(vm.resolve.employeeId) && vm.resolve.employeeId != null) != null
        vm.hasApprovedOnboardingProfile = vm.resolve.onboardingApplication != null && vm.resolve.onboardingApplication.length > 0 && vm.resolve.onboardingApplication.find(x => x.EmployeeId === Number(vm.resolve.employeeId) && vm.resolve.employeeId != null) != null && vm.resolve.onboardingApplication[0].ApplicationStatus === 'Approved';
        vm.addlInputs = vm.resolve.addlInputs;
        vm.application = vm.resolve.onboardingApplication != null && vm.resolve.onboardingApplication.length > 0 ? vm.resolve.onboardingApplication[0] : null;
        vm.isRehire = vm.resolve.rehire ?? false;
        vm.isOnboard = vm.resolve.onboard ?? false;
        // Existing employees keep their real (often older) hire date; the picker min must not
        // clamp/blank it. New hires & rehires keep the one-year-ago floor. JS re-validates on change.
        vm.hireDateMin = (!vm.resolve.isNew && !vm.isRehire) ? new Date(1900, 0, 1) : vm.oneYearAgo;
        if (vm.isOnboard && vm.resolve.employee?.EmailAddress) {
            onChangeEmailAddress(vm.resolve.employee.EmailAddress);
        }
        //vm.hireDate = new Date();
        vm.retrieveLocale().then(function (locale) {
            console.log(locale);
            return vm.retrieveLocaleTranslations(locale.localeID);
        }).then(function (translations) {
            vm.Translations = translations;
        });


        vm.getEmployeeModel = employeeService.retrieveNewEmployeeModel();
        const employmentStatuses = employeeService.retrieveEmployeeStatuses();
        const moduleAdminIcdOffices = icdOfficeService.retrieveIcdOffices({ moduleID: ROSTER_MODULE })
            .then(icdOffices => icdOffices.sort(sortIcdOfficeByOwner));
        const jobTitles = employeeService.retrieveJobTitles();
        const basisOfPay = employeeService.retrieveBasisOfPay();

        const payFrequencies = payrollService.retrievePayFrequencies();
        const departments = employeeService.retrieveCompensationProfiles();
        // These are the assignable roles that the current user is able to assign to any office.
        const assignableRoles = employeeService.retrieveEmployeeAssignableRoles().then(loadRoleDescriptions);
        vm.getWagePolicies = wagePolicyService.retrieveTodayWagePolicies();
        const terminationReasons = employeeService.retrieveTerminationReasons();
        const stateProvinces = stateProvinceService.retrieveStateProvinces();
        const roleAccessLoaded = employeeService.retrievePermissions({
            module: SiteModuleEnum.Roster
        }).then(roleAccess => vm.roleAccess = roleAccess);

        const payrollAccessLoaded = employeeService.retrievePermissions({
            stateName: "report.payrollProcessing"
        }).then(payrollAccess => vm.payrollAccess = payrollAccess);

        const identityLoaded = employeeService.retrieveIdentity()
            .then(identity => {
                vm.userID = identity.EmployeeID;
                vm.identity = identity;
            });
        return $q.all([
            vm.getEmployeeModel,
            employmentStatuses,
            moduleAdminIcdOffices,
            jobTitles,
            basisOfPay,
            payFrequencies,
            departments,
            assignableRoles,
            terminationReasons,
            vm.getWagePolicies,
            roleAccessLoaded,
            payrollAccessLoaded,
            identityLoaded,
            stateProvinces
        ]).then(function ([employee, statuses, offices, jobTitles, basisOfPay, payFrequencies, departments,
            roles, terminationReasons, wagePolicies, provinces]) {

            // Preload employment record to a specific office.
            if (vm.resolve.icdOfficeID != null) {
                // Pre-select the office appearing in the dropdown.
                employee.IcdOffices.forEach(function (office) {
                    // If the office is unset, pre-fill it as the office from the query string.
                    if (!office.IcdOfficeID) {
                        office.IcdOfficeID = vm.resolve.icdOfficeID;
                    }
                });
            }
            if (vm.identity.IsSiteAdmin) {
                ///change logic to add office
                employee.IcdOffices = [];
            }
            if (!employee.GlobalRoles.length) {
                // Change global roles from a roleID dict to an array.
                employee.GlobalRoles = roles.filter(p => p.GlobalRole)
                    .map(function (role) {
                        return mapEmployeeRole(role, !!employee.GlobalRoles[role.Id]);
                    });
            }
            vm.context = employmentRecordEditContextFactory(employee, offices, statuses,
                terminationReasons, payFrequencies, jobTitles, departments, wagePolicies, basisOfPay, provinces);


            if (vm.context.employee && vm.context.icdOffices != null) {
                vm.icdOffice = vm.context.icdOffices[0];
                if (vm.icdOffice && !vm.icdOffice.WagePolicy) {
                    vm.icdOffice.WagePolicy = vm.context.wagePolicies.filter(wagePolicy =>
                        wagePolicy.StateName === vm.icdOffice.OfficeState)[0];
                    vm.wagePolicy = vm.icdOffice.WagePolicy;
                }
            }
            vm.employee = employee;

            vm.compensationProfiles = departments;
            vm.basisOfPay = basisOfPay;
            vm.compensationProfilesbk = departments;
            vm.telemapperLinked = vm.resolve.telemapperLinked;
            if (vm.resolve.isNew) {
                vm.employee.EmailOnboarding = true;
                vm.onbEmail = true
                vm.fullName = vm.empContractor === 2 ? 'Contractor' : 'Employee';
                var allowedRoleIds = [6, 8, 11, 12];
                vm.rolelist = roles.map(function (role) {
                    return {
                        RoleID: role.Id,
                        Name: role.Name,
                        Description: role.Description,
                        IsInRole: false,//!vm.resolve.IcdOffices[0].Roles[role.Id],
                        AdministeredModules: role.AdministeredModules,
                        selected: false
                    };
                }).filter(function (role) {
                    //return !role.IsSuperUser && !role.GlobalRole;
                    return allowedRoleIds.includes(role.RoleID);

                });
            } else {

                console.log(vm.editForm);
                if (vm.addlInputs != null && vm.addlInputs.hasOwnProperty("OnboardingType")) {
                    vm.empContractor = vm.addlInputs["OnboardingType"] === "e" ? 1 : 2;
                    if (vm.empContractor === 2) {
                        vm.isIndividualOrCompany = vm.addlInputs["OnboardingType"];
                    } else {
                        vm.isIndividualOrCompany = 'e'
                    }
                } else {

                    if (vm.resolve.onboardingApplication != null) {
                        if (vm.resolve.onboardingApplication[0].Is1099) {
                            vm.empContractor = 2;
                        } else if (!vm.resolve.onboardingApplication[0].Is1099) {
                            vm.empContractor = 1;
                        }
                    }
                }
                vm.user = vm.resolve.employee;
                vm.FirstName = vm.user.FirstName;
                vm.LastName = vm.user.LastName;
                vm.MiddleName = vm.user.MiddleName;
                vm.fullName = vm.resolve.employee.FullName;
                vm.UserName = vm.user.UserName;
                vm.EmailAddress = vm.user.EmailAddress;
                vm.onbEmail = vm.user.EmailOnboarding;
                vm.smsEmail = vm.user.SmsOnboarding;
                vm.PhoneNumber = formatPhoneNumber(vm.resolve.userProfile?.HomePhone?.PhoneNumber);
                //if (vm.UserName) {
                //    vm.isMeridianDuplicate = vm.UserName.startsWith('m') && vm.UserName.includes('+');
                //    if (vm.isMeridianDuplicate) {
                //        validateUserNameAvailability(vm.EmailAddress).then((res) => {
                //            if (res) {
                //                vm.UserName = vm.EmailAddress;
                //            } else {
                //                vm.UserName = vm.user.Id + "@apex";
                //                return validateUserNameAvailability(vm.UserName);
                //            }
                //        })
                //    }
                //}

                /* vm.employeeState = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateToBeTaxedIn);*/

                if (vm.telemapperLinked && !vm.hasOnboardingProfile) {
                    vm.employeeState = null;
                    vm.employeeState2 = null;
                }

                //todo: move name to seperate dataset/ table
                if (vm.resolve.employee.IcdOffices && vm.resolve.employee.IcdOffices.length > 0) {
                    let office = vm.resolve.employee.IcdOffices[0];
                    var allowedRoleIds = [6, 8, 11, 12];
                    var officeRoles = office.Roles; // Example office roles
                    const roleHierarchy = {
                        12: 2, // Admin (Highest)
                        8: 1,  // Team Manager
                        6: 3,  // Sr. Brand Rep
                        11: 4   // Sales Rep (Lowest)
                    };
                    //const filteredRoles = getHighestRole(roles);
                    // Find the highest-ranked role from the available roles
                    let roleKeys = Object.keys(officeRoles)
                    const highestRole = roleKeys.reduce((highest, role) => {
                        if (!highest || (roleHierarchy[role] || 99) < (roleHierarchy[highest] || 99)) {
                            return role; // Update highest if the current role has a better (lower) priority
                        }
                        return highest;
                    }, null);
                    vm.rolelist = roles.map(function (role) {
                        return {
                            RoleID: role.Id,
                            Name: role.Name,
                            Description: role.Description,
                            IsInRole: false, //!vm.resolve.IcdOffices[0].Roles[role.Id],
                            AdministeredModules: role.AdministeredModules,
                            selected: highestRole && role.Id.toString() === highestRole
                        };
                    }).filter(function (role) {
                        //return !role.IsSuperUser && !role.GlobalRole;
                        return allowedRoleIds.includes(role.RoleID);
                    });

                    //vm.rolelist = roles.map(function (role) {
                    //    return {
                    //        RoleID: role.Id,
                    //        Name: role.Name,
                    //        Description: role.Description,
                    //        IsInRole: false,//!vm.resolve.IcdOffices[0].Roles[role.Id],
                    //        AdministeredModules: role.AdministeredModules,
                    //        selected: !!officeRoles[role.Id]
                    //    };
                    //}).filter(function (role) {
                    //    //return !role.IsSuperUser && !role.GlobalRole;
                    //    return allowedRoleIds.includes(role.RoleID);
                    //});

                    vm.selectedRoleID = vm.rolelist.find(role => role.selected)?.RoleID || null;
                    if (office.HireDate && !vm.isRehire) {
                        vm.hireDate = new Date(office.HireDate)
                        // remember the prefilled (existing) hire date so the
                        // one-year-ago rule is only applied to a newly entered date
                        vm.originalHireDate = vm.hireDate
                    }
                    if (office.PayRate != null) {
                        vm.PayRate = office.PayRate;
                    }
                    if (office.Salary) {
                        vm.salary = office.Salary;
                    }
                    if (office.DefaultHours) {
                        vm.DefaultHours = office.DefaultHours;
                    }
                    if (office.CompensationProfileID) {
                        if (office.CompensationProfileID === 5) {
                            //vm.empContractor = 2;
                            if (!vm.resolve.isNew && vm.hasOnboardingProfile && !vm.isRehire) {
                                vm.compensationProfiles = vm.compensationProfiles.filter(item => item.Id === 5);
                            }
                        } else {
                            //vm.empContractor = 1;
                            if (!vm.resolve.isNew && vm.hasOnboardingProfile && !vm.isRehire) {
                                vm.compensationProfiles = vm.compensationProfiles.filter(item => item.Id !== 5);
                            }
                        }
                        vm.CompensationProfile = vm.compensationProfiles.find(x => x.Id === office.CompensationProfileID);
                    }
                    if (office.BasisOfPayID) {
                        vm.BasisOfPay = vm.basisOfPay.find(x => x.BasisOfPayId === office.BasisOfPayID);
                    }

                }
                if (vm.empContractor === 2) {
                    vm.employeeState2 = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateWorkingIn);
                } else {
                    vm.employeeState = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateToBeTaxedIn);
                    vm.employeeState2 = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateWorkingIn);
                }
                vm.diffTaxState = vm.resolve.employeeBankInfo.AddressStateProvinceID && vm.employeeState != null && vm.employeeState.StateProvinceID !== vm.resolve.employeeBankInfo.AddressStateProvinceID

                vm.initData = {
                    FirstName: vm.FirstName,
                    LastName: vm.LastName,
                    StateTaxedIn: vm.employeeState,
                    StateWorkingIn: vm.employeeState2,
                    HireDate: vm.hireDate ? new Date(vm.hireDate).toISOString().split('T')[0] : null,
                    Department: vm.CompensationProfile
                };

            }
            return;
        }).catch(function (ex) {
            if (ex.status === 401) {
                // Expected if the user changed their own user name.
                vm.employeeForm.$setPristine();
                // Reload the page, which will redirect to the signin form.
                window.location.reload();
                return;
            }
            vm.modelState = ex.data ? ex.data.ModelState : null;
            utilityService.hideLoading();
            alert("Saving failed: " + utilityService.getExceptionMessage(ex));
        }).finally(() => {
            utilityService.hideLoading();
        });
    }

    //$scope.$watch('vm.UserName', function (newVal, oldVal) {
    //    if (newVal !== oldVal) {

    //    }
    //}, true);
    vm.updateSelection = function (selectedRole) {
        // Reset all roles' `selected` states
        vm.rolelist.forEach(role => role.selected = false);

        // Set the selected role's state to true
        selectedRole.selected = true;
        vm.selectedRoleId = selectedRole.RoleID;
    };

    function showMinimumWageRequirements() {

        return $uibModal.open({
            ...MinimumWageReviewModal,
            resolve: {
                wagePolicies: () => vm.context.wagePolicies,
                selectedOffice: () => vm.icdOffice,
                stateWorkingIn: () => vm.employeeState2?.StateProvinceID ?? null
            }
        }).result.catch((err) => {
            console.log(err);
        });
    }


    function onChangeCompensationProfile() {
        //vm.CompensationProfileID = vm.CompensationProfile ? vm.CompensationProfile.Id : null;
    }

    function onChangeUserName(userName) {
        vm.editForm.UserName.$setValidity("inprogress", false);
        validateUserNameAvailability(userName)
            .catch(() => { })
            .finally(() => vm.userNamePending = false);
    }

    function onChangePhoneNumber(phone) {
        vm.onbPhone = !!phone;
        // Clear any prior server-side phone validation error once the user edits the number.
        vm.phoneServerError = null;

        // Auto-format to xxx-xxx-xxxx and flag (soft, non-blocking) when more than 10 digits entered.
        vm.phoneTooLong = (phone || "").replace(/[^0-9]/g, "").length > 10;
        vm.PhoneNumber = formatPhoneNumber(phone);
        //if (phone && !vm.onbPhone) {
        //    vm.editForm.smsonb.$setValidity("required", false);
        //} else {
        //    vm.editForm.smsonb.$setValidity("required", true);
        //}
    }

    function formatPhoneNumber(phone) {
        const digits = (phone || "").replace(/[^0-9]/g, "");
        const base = digits.substring(0, 10);
        let formatted;
        if (base.length > 6) {
            formatted = base.substring(0, 3) + "-" + base.substring(3, 6) + "-" + base.substring(6);
        } else if (base.length > 3) {
            formatted = base.substring(0, 3) + "-" + base.substring(3);
        } else {
            formatted = base;
        }
        // Keep any overflow digits visible so the >10 warning stays meaningful.
        if (digits.length > 10) {
            formatted += digits.substring(10);
        }
        return formatted;
    }

    function onChangeEmailAddress(email) {
        vm.duplicates = [];
        if (vm.resolve.isNew || vm.isOnboard) {
            vm.triggerDuplCheck = true;
        } else {
            vm.triggerDuplCheck = vm.resolve.employee.EmailAddress.toLowerCase() !== email.toLowerCase();
        }
        if (!email) return;
        vm.emailAddressPending = true;
        var request = {
            EmailAddress: email, EmployeeID: vm.resolve.employeeId, IcdCorporationID: vm.resolve.icdCorporation.Id
        };

        employeeService.checkForDuplicates(request)
            .then(duplicates => {
                if (duplicates && duplicates.length > 0) {
                    vm.duplicates = duplicates;
                }
            })
            .catch(() => { })
            .finally(() => vm.emailAddressPending = false);
    }

    function validateUserNameAvailability(userName) {
        return isEmailAddressAvailable(userName)
            .then(available => {
                vm.editForm.UserName.$setValidity("available", available);
                vm.editForm.UserName.$setValidity("inprogress", true);
                return available; // Return the availability status for further handling if needed
            });
    }

    //$scope.$watch('vm.hireDate', function (newVal, oldVal) {
    //    validateHireDate();
    //});
    $scope.$watch(
        () => vm.hireDate,
        function (newVal, oldVal) {
            if (newVal === oldVal) return;
            validateHireDate();
        }
    );
    function normalizeDate(d) {
        if (!d) {
            return null;
        }

        // Ensure it's a Date object
        d = d instanceof Date ? d : new Date(d);

        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    // true when the current hire date is the unchanged prefilled (existing) date;
    // used to skip the one-year-ago validation for existing employees
    function isExistingHireDate() {
        if (!vm.originalHireDate || !vm.hireDate) {
            return false;
        }
        var orig = normalizeDate(vm.originalHireDate);
        var current = normalizeDate(vm.hireDate);
        return orig != null && current != null && orig.getTime() === current.getTime();
    }

    function validateHireDate() {
        if (!vm.editForm || !vm.editForm.HireDate) {
            return; // form or control not yet available
        }
        var oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        if (vm.hireDate == null) {
            vm.editForm.HireDate.$setValidity('valid', true);
            vm.editForm.HireDate.$setValidity('required', false);
        } else if (!isValidDate(vm.hireDate.toLocaleDateString())) {
            vm.editForm.HireDate.$setValidity('required', true);
            vm.editForm.HireDate.$setValidity('valid', false);
        } else if (vm.hireDate != null && !isExistingHireDate() && normalizeDate(vm.hireDate) < normalizeDate(oneYearAgo)) {
            vm.editForm.HireDate.$setValidity('valid', false);
        } else {
            vm.editForm.HireDate.$setValidity('valid', true);
            vm.editForm.HireDate.$setValidity('required', true);
        }
    }

    function isValidDate(dateString) {
        // Check if the date string matches the MM/dd/yyyy format using a regular expression
        //var dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
        //if (!dateRegex.test(dateString)) {
        //    return false; // Return false if the date format is invalid
        //}
        return !isNaN(Date.parse(dateString))
        // Return true if the date is valid
    }

    function isEmailAddressAvailable(userName) {
        if (userName === vm.originalUserName) {
            return $q.resolve(true);
        }
        return employeeService.isEmailAddressAvailable(userName).then((res) => {
            return res
        });
    }

    function matchStates() {
        vm.resolve.employeeBankInfo.StateToBeTaxedIn = vm.resolve.employeeBankInfo.AddressStateProvinceID;
        if (vm.empContractor === 2) {
            vm.employeeState = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateWorkingIn);
        } else {
            vm.employeeState = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateToBeTaxedIn);
        }
        //vm.employeeState = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.resolve.employeeBankInfo.StateToBeTaxedIn);
        vm.diffTaxState = true;
    }


    function syncFormToProfile() {
        //let profilePromises = [];
        vm.resolve.userProfile.FirstName = vm.FirstName;
        vm.resolve.userProfile.LastName = vm.isIndividualOrCompany !== 'c' ? vm.LastName : ' ';
        if (vm.empContractor === 2) {
            vm.resolve.employeeBankInfo.StateWorkingIn = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.employeeState2.StateProvinceID)?.StateProvinceID;
        } else {
            vm.resolve.employeeBankInfo.StateToBeTaxedIn = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.employeeState.StateProvinceID)?.StateProvinceID;
            vm.resolve.employeeBankInfo.StateWorkingIn = vm.resolve.stateProvinces.find(x => x.StateProvinceID === vm.employeeState2.StateProvinceID)?.StateProvinceID;
        }
    }

    function validateMinimumWage() {
        console.log('trigger');
        if (vm.icdOffice) {
            if (vm.employeeState2 != null) {
                let wp = vm.context.wagePolicies.filter(wagePolicy => wagePolicy.StateName === vm.employeeState2.StateName)[0];
                vm.icdOffice.WagePolicy = wp;
                vm.wagePolicy = wp;
            }
            /*let wp = vm.icdOffice.WagePolicy;*/

            const belowMinimumWage = vm.icdOffice.WagePolicy && vm.PayRate < vm.icdOffice.WagePolicy.MinimumWage && vm.CompensationProfile != null && vm.CompensationProfile.Id === 3 //departmentList.dept400;
            vm.editForm.PayRate.$setValidity("belowMinimumWage", !belowMinimumWage);
            vm.testMsg = 'min wage error 2';
            return true;
        }
        return false;

    }

    function onRehire() {
        if (vm.editForm && vm.editForm.$invalid) {
            return;
        }
        return onSubmit(true, true);
    }

    function onSubmit(triggerOnboarding, isRehire) {
        if (vm.editForm && vm.editForm.$invalid) return;

        if (vm.isIndividualOrCompany == null) {
            alert("Please select a contractor type");
            return;
        }

        vm.phoneServerError = null;
        utilityService.showLoading();

        // Up-front phone validation gate: check the number via Twilio Lookup BEFORE creating
        // or onboarding anything. If the provider confirms it is invalid, stop and show the
        // error inline; nothing is created.
        // Fail open: if the validation call itself errors (network/500/etc.), do NOT block
        // onboarding — the server-side lookup is already fail-open by design.
        var validatePhone = (vm.PhoneNumber
            ? employeeService.validatePhoneNumber(vm.PhoneNumber)
            : $q.resolve(true)
        ).catch(function () {
            return true;
        });

        var corpId = vm.resolve.icdCorporation?.Id;
        var fetchCorp = corpId
            ? icdCorporationService.retrieveIcdCorporation(corpId)
            : $q.resolve(vm.resolve.icdCorporation);

        return validatePhone.then(function (isPhoneValid) {
            if (isPhoneValid === false) {
                utilityService.hideLoading();
                vm.phoneServerError = "The phone number entered is not a valid phone number.";
                return $q.reject({ handledPhoneError: true });
            }
            return fetchCorp;
        }).then(function (freshCorporation) {
            utilityService.hideLoading();

            // Bug fix 1&2: initialize hasTaxInfo and errorState before conditional blocks
            vm.hasTaxInfo = true;
            var errorState = [];

            if (freshCorporation != null && freshCorporation.IcdCorporationTaxInfos != null) {
                if (vm.empContractor === 1) {
                    var sitCheck = freshCorporation.IcdCorporationTaxInfos.some(x =>
                        Number(x.State) === vm.employeeState?.StateProvinceID && x.Name === 'State Income Tax'
                    );
                    var suiCheck = freshCorporation.IcdCorporationTaxInfos.some(x =>
                        Number(x.State) === vm.employeeState2?.StateProvinceID && x.Name === 'State Unemployment Insurance'
                    );
                    if (!sitCheck) errorState.push(vm.employeeState.StateProvinceID);
                    if (!suiCheck) errorState.push(vm.employeeState2.StateProvinceID);
                    vm.hasTaxInfo = sitCheck && suiCheck;
                } else if (vm.empContractor === 2) {
                    vm.hasTaxInfo = true;
                }
            }

            if (!vm.hasTaxInfo) {
                var taxState = errorState.map(item =>
                    vm.resolve.stateProvinces.find(x => x.StateProvinceID === item)?.StateName
                ).filter(Boolean);
                var taxStateStr = taxState.length ? taxState.join(', ') : 'State';
                alert("Your company is currently not setup for taxation in " + taxStateStr + " selected. \nPlease reach out to Apex Support for further assistance.\nEmail: ApexSupport@herbjoyent.com.\nPhone: 1-877-822-6505");
                return;
            }

            // Implemented online Province W-4 states (single source of truth)
            var implementedStateArr = IMPLEMENTED_PROVINCE_STATE_IDS;

            // Bug fix 5: build rolesObject once
            var rolesObject = {};
            var isRoleSelected = false;
            vm.rolelist.forEach(function (role) {
                rolesObject[role.RoleID] = role.RoleID === vm.selectedRoleID;
                if (role.RoleID === vm.selectedRoleID) isRoleSelected = true;
            });

            // Build state info once
            var stateInfo = vm.empContractor === 2
                ? { StateWorkingIn: vm.employeeState2.StateProvinceID }
                : { StateToBeTaxedIn: vm.employeeState.StateProvinceID, StateWorkingIn: vm.employeeState2.StateProvinceID };

            var proceed = function () {
                if (!isRoleSelected) {
                    alert("Please select at least one role");
                    utilityService.hideLoading();
                    return $q.resolve();
                }

                if (vm.resolve.isNew) {
                    vm.employee.FirstName = vm.FirstName;
                    vm.employee.MiddleName = vm.isIndividualOrCompany !== 'c' ? vm.MiddleName : null;
                    vm.employee.LastName = vm.isIndividualOrCompany !== 'c' ? vm.LastName : ' ';
                    vm.employee.EmailAddress = vm.EmailAddress;
                    vm.employee.UserName = vm.UserName;
                    vm.employee.SendWelcomeEmail = false;
                    vm.employee.EmailOnboarding = true;
                    vm.employee.SmsOnboarding = vm.onbPhone ?? false;
                    vm.employee.MobilePhone = vm.PhoneNumber;

                    if (vm.employee.IcdOffices.length === 0) {
                        vm.employee.IcdOffices.push({ Roles: {} });
                    }

                    var office = vm.employee.IcdOffices[0];
                    office.Roles = rolesObject;
                    office.JobTitleID = 5;
                    office.CompensationProfileID = vm.CompensationProfile.Id;
                    office.BasisOfPayID = vm.CompensationProfile.Id === 5 ? null : vm.BasisOfPay.BasisOfPayId;
                    office.HireDate = vm.hireDate.toISOString().slice(0, 10);
                    office.PayRate = vm.PayRate;

                    if (vm.salary) {
                        office.Salary = vm.salary;
                        if (vm.CompensationProfile.Id === 2) {
                            office.DefaultHours = vm.DefaultHours;
                        }
                    }

                    var div = office.Divisions;
                    if (div != null && div.length > 0) {
                        if (div[0].DefaultRotationLengthTypeID === 2 && div[0].DefaultRotationLength === 1) office.PayFrequencyID = 1;
                        if (div[0].DefaultRotationLengthTypeID === 2 && div[0].DefaultRotationLength === 2) office.PayFrequencyID = 2;
                    }

                    // Bug fix 4: use $q.resolve() not Promise.resolve()
                    var warningPromise = (vm.empContractor === 1
                        && implementedStateArr.indexOf(vm.employeeState.StateProvinceID) === -1
                        && vm.employeeState.IsW4Required && !vm.employeeState.IsStateExemptOnly)
                        ? $uibModal.open({
                            windowClass: 'modal-dialog-centered',
                            template: `<div class="modal-header"></div>
                              <div class="modal-body"><p>{{$ctrl.message}}</p></div>
                              <div class="modal-footer">
                                  <button class="btn btn-primary" ng-click="$ctrl.continue()">Continue</button>
                                  <button class="btn btn-secondary" ng-click="$ctrl.goBack()">Go Back</button>
                              </div>`,
                            controllerAs: '$ctrl',
                            controller: function ($uibModalInstance) {
                                'ngInject';
                                this.message = "The Tax form for " + vm.employeeState.StateName + " will be coming in the future. Until then, please ensure that you are completing the paper form outside of Apex.You will need to ensure that paper copies are kept with your organization for 7 years";
                                this.continue = () => $uibModalInstance.close(true);
                                this.goBack = () => $uibModalInstance.dismiss();
                            }
                        }).result
                        : $q.resolve();

                    return warningPromise.then(() => {
                        utilityService.showLoading();

                        var formData = {
                            EmployeeId: null,
                            FirstName: vm.FirstName,
                            LastName: vm.isIndividualOrCompany !== 'c' ? vm.LastName : ' ',
                            MiddleName: vm.MiddleName,
                            EmailAddress: vm.EmailAddress,
                            UserName: vm.UserName,
                            HireDate: vm.hireDate,
                            CompensationProfileID: vm.CompensationProfile.Id,
                            PayRate: vm.PayRate,
                            DefaultHours: vm.DefaultHours,
                            PayFrequencyID: office.PayFrequencyID,
                            JobTitleID: 5,
                            BasisOfPayID: vm.CompensationProfile.Id === 5 ? null : vm.BasisOfPay.BasisOfPayId,
                            EmailOnboarding: true,
                            SmsOnboarding: vm.onbPhone ?? false,
                            MobilePhone: vm.PhoneNumber,
                            GlobalRoles: rolesObject,
                            ...(vm.salary ? { Salary: vm.salary } : {}),
                            ...stateInfo
                        };

                        return employeeService.saveOnboardingEmployee(vm.employee)
                            .then(function (employee) {
                                vm.editForm.$setPristine();
                                vm.employeeID = employee.Id;
                                formData.EmployeeId = vm.employeeID;
                                return employeeService.updateEmployeeProfileForOnboarding(vm.employeeID, formData);
                            })
                            .then(res => {
                                if (res.status !== 200) {
                                    alert("Saving failed");
                                    utilityService.hideLoading();
                                    return $q.reject();
                                }
                                var onboardingType = vm.empContractor === 2 ? vm.isIndividualOrCompany : 'e';
                                return onboardingDocumentService.setAddlInput(vm.employeeID, "OnboardingType", onboardingType);
                            })
                            .then(() =>
                                triggerOnboarding ? employeeService.initOnboardingEmployee(vm.employeeID, triggerOnboarding) : $q.resolve(null))
                            .then(result => result ? permissionGrantService.setOnboardingFormPermissions(vm.employeeID) : $q.resolve(null))
                            .then(() => {
                                utilityService.hideLoading();
                                return vm.close({ $value: 'success' });
                            });

                    }).catch(function (ex) {
                        if (ex?.status === 401) {
                            window.location.reload();
                            return;
                        }
                        vm.modelState = ex?.data?.ModelState ?? null;
                        utilityService.hideLoading();
                        alert("Saving failed: " + utilityService.getExceptionMessage(ex));
                    });

                } else {
                    // Edit path
                    syncFormToProfile();
                    vm.reqFormChange = true;
                    var editData = [];
                    var finalData = [];

                    angular.forEach(vm.editForm.$$controls, function (field) {
                        if (!field || !field.$name) return;
                        var currentValue = field.$$controls?.length ? field.$$controls[0].$viewValue : field.$viewValue;
                        var initialValue = vm.initData?.[field.$name];
                        if ((initialValue !== undefined || (vm.isOnboard && field.$name === 'StateTaxedIn')) && currentValue !== initialValue) {
                            editData[field.$name] = currentValue;
                        }
                    });

                    finalData = vm.resolve.changeFormMapping.filter(item => {
                        if (!editData[item.FieldName]) return false;
                        if (item.StateFilterRaw) return item.StateFilter.indexOf(vm.employeeState.StateProvinceID) !== -1;
                        return true;
                    });

                    var warningPromise = $q.resolve();

                    if (finalData && finalData.length) {
                        var ids = [];

                        angular.forEach(finalData, function (f) {
                            if (vm.isOnboard && f.FieldName === 'StateTaxedIn') return;
                            if (ids.indexOf(f.FormID) === -1) ids.push(f.FormID);
                        });

                        var paperFormsRequired = false;
                        var allowedList = ids.reduce((acc, id) => {
                            var item = { id, name: vm.formMapping[id] };
                            if (id === 5 && !vm.application.Is1099) acc.push(item);
                            else if (id === 2) {
                                if (vm.empContractor === 1 && implementedStateArr.indexOf(vm.employeeState.StateProvinceID) === -1 &&
                                    vm.employeeState.IsW4Required && !vm.employeeState.IsStateExemptOnly) paperFormsRequired = true;
                                acc.push(item);
                            } else if (id === -2 && vm.application.Is1099) acc.push(item);
                            else if (id === 3) acc.push(item);
                            return acc;
                        }, []);

                        // Skip the re-sign confirmation for rehire and terminated-update flows
                        var skipResignWarning = isRehire || vm.isOnboard || (vm.application && vm.application.EmployeeStatus === 'Terminated');
                        if (allowedList.length && !skipResignWarning) {
                            var name = allowedList.map(i => i.name).join(', ');
                            var stateName = paperFormsRequired ? "for " + vm.employeeState.StateName : "";
                            warningPromise = $uibModal.open({
                                windowClass: 'modal-dialog-centered',
                                template: `<div class="modal-header"></div>
                                  <div class="modal-body">
                                      <p>{{$ctrl.message}}</p>
                                      <p ng-if="$ctrl.paperFormsRequired">{{$ctrl.paperMessage}}</p>
                                  </div>
                                  <div class="modal-footer">
                                      <button class="btn btn-outline-secondary" ng-click="$ctrl.goBack()">Go Back</button>
                                      <button class="btn btn-primary" ng-click="$ctrl.continue()">Continue</button>
                                  </div>`,
                                controllerAs: '$ctrl',
                                controller: function ($uibModalInstance) {
                                    'ngInject';
                                    this.message = "For your changes to be finalized, the following forms will have to be re-signed: " + name;
                                    this.paperMessage = "The Tax form " + stateName + " will be coming in the future. Until then, please ensure that you are completing the paper form outside of Apex.You will need to ensure that paper copies are kept with your organization for 7 years";
                                    this.paperFormsRequired = paperFormsRequired;
                                    this.continue = () => $uibModalInstance.close(true);
                                    this.goBack = () => $uibModalInstance.dismiss();
                                }
                            }).result;
                        }
                        //else {
                        //    warningPromise = Promise.resolve()
                        //}
                    }

                    return warningPromise.then(() => {
                        utilityService.showLoading();

                        var div = vm.resolve.employee.IcdOffices[0].Divisions;
                        var payFreq = (div?.length && div[0].DefaultRotationLengthTypeID === 2)
                            ? div[0].DefaultRotationLength === 1 ? 1 : 2
                            : 1;

                        var formData = {
                            EmployeeId: vm.resolve.employeeId,
                            FirstName: vm.FirstName,
                            LastName: vm.isIndividualOrCompany !== 'c' ? vm.LastName : ' ',
                            MiddleName: vm.MiddleName,
                            EmailAddress: vm.EmailAddress,
                            UserName: vm.UserName,
                            HireDate: vm.hireDate,
                            CompensationProfileID: vm.CompensationProfile.Id,
                            PayRate: vm.PayRate,
                            Salary: vm.salary,
                            DefaultHours: vm.DefaultHours,
                            PayFrequencyID: payFreq,
                            JobTitleID: 5,
                            BasisOfPayID: vm.CompensationProfile.Id === 5 ? null : vm.BasisOfPay.BasisOfPayId,
                            EmailOnboarding: true,
                            SmsOnboarding: vm.onbPhone ?? false,
                            MobilePhone: vm.PhoneNumber,
                            GlobalRoles: rolesObject,
                            ...stateInfo
                        };

                        return employeeService.updateEmployeeProfileForOnboarding(vm.resolve.employeeId, formData)
                            .then(res => {
                                if (res.status !== 200) {
                                    return $q.reject(res);
                                }
                                if (isRehire) {
                                    return employeeService.rehireOnboardingEmployee(vm.resolve.employeeId).then(result => ({
                                        result, runPermissions:
                                            true
                                    }));
                                }
                                if (triggerOnboarding) {
                                    return employeeService.initOnboardingEmployee(vm.resolve.employeeId, triggerOnboarding).then(result => ({
                                        result, runPermissions: true
                                    }));
                                }
                                return $q.resolve({ result: null, runPermissions: false });
                            })
                            .then(({ result, runPermissions }) => runPermissions ? permissionGrantService.setOnboardingFormPermissions(vm.resolve.employeeId) : $q.resolve(null))
                            .then(() => (!isRehire && !triggerOnboarding && vm.application && vm.application.EmployeeStatus === 'Terminated')
                                ? $q.resolve()
                                : onboardingDocumentService.updateFormChange(vm.application.ApplicationNumber, finalData, true, vm.application.MissingOnboardingInfo))
                            .then(() => {
                                utilityService.hideLoading();
                                return vm.close({ $value: 'success' });
                            }).catch(err => {
                                console.log(err);
                                return $q.reject(err);   // keep the chain rejected so nothing downstream treats it as success
                            });

                    }).catch(err => {
                        utilityService.hideLoading();
                        if (!err || !err.data && !err.statusText) return;   // modal dismiss / cancel ? silent
                        alert((err.data && (err.data.ExceptionMessage || err.data.Message))
                            || (typeof err.data === 'string' && err.data)
                            || err.statusText || 'Saving failed');
                    });
                }
            }; // end proceed

            if (vm.duplicates && vm.duplicates.length > 0 && vm.triggerDuplCheck) {
                return $uibModal.open({
                    windowClass: 'modal-dialog-centered',
                    template: `<div class="modal-header"><h4 class="modal-title">Duplicate Profile(s) found</h4></div>
                      <div class="modal-body" style="max-height: 60vH; overflow-y: auto;">
                          <p>The following employees already use this email address:</p>
                          <ul><li ng-repeat="emp in $ctrl.duplicates">{{emp.FirstName}} {{emp.LastName}} &mdash; <strong>{{emp.UserName}}</strong></li></ul>
                          <p>This may be a duplicate profile. Do you want to continue?</p>
                      </div>
                      <div class="modal-footer">
                          <button class="btn btn-primary" ng-click="$ctrl.continue()">Continue</button>
                          <button class="btn btn-secondary" ng-click="$ctrl.goBack()">Go Back</button>
                      </div>`,
                    controllerAs: '$ctrl',
                    controller: function ($uibModalInstance) {
                        'ngInject';
                        this.duplicates = vm.duplicates;
                        this.continue = () => $uibModalInstance.close(true);
                        this.goBack = () => $uibModalInstance.dismiss();
                    }
                }).result.then(() => proceed()).catch(() => { });
            }

            return proceed();
        }).catch(function (submitError) {
            // Always clear the spinner so the user is never left stuck.
            utilityService.hideLoading();
            // The up-front phone gate rejects with handledPhoneError after showing the inline
            // message; nothing else to do in that case.
            if (submitError && submitError.handledPhoneError) {
                return;
            }
            // Surface any other unexpected error instead of failing silently.
            alert("Saving failed: " + utilityService.getExceptionMessage(submitError));
        });
    }

    function setContractor(empContractor) {
        vm.empContractor = empContractor;
        if (empContractor === 2) {
            vm.compensationProfiles = vm.compensationProfilesbk.filter(x => x.Id === 5);
            vm.CompensationProfile = vm.compensationProfilesbk.find(x => x.Id === 5)
        } else {
            vm.compensationProfiles = vm.compensationProfilesbk.filter(x => x.Id !== 5);
            vm.CompensationProfile = null;
        }
    }

    function mapEmployeeRole(role, isInRole) {
        return {
            RoleID: role.Id,
            Name: role.Name,
            Description: role.Description,
            IsInRole: isInRole,
            AdministeredModules: role.AdministeredModules
        };
    }

    function loadRoleDescriptions(roles) {
        return $q.when(roles)
            .then(function (roles) {
                return $q.all(roles.map(function (role) {
                    if (!role.Description || role.Description[0] !== "|") {
                        return $q.when(role);
                    }
                    // Translate the description using the locale service.
                    return localeService.retrieveCurrentLocaleTranslations()
                        .then(function (translations) {
                            role.Description = translations[role.Description.slice(1)];
                            return role;
                        });
                }));
            });
    }

    function onClose() {
        /*vm.close({ $value: null });*/
        //$state.go("^");
        vm.close({ $value: 'cancel' });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        var countryID = vm.resolve.employeeBankInfo?.CountryID ?? 0
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(countryID);
                return locales.filter(function (locale) {
                    return locale.countryID === countryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }
}


export const PendingEmployeeModal = {
    component: "apexPendingEmployeeModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
};
